
import styled from 'styled-components';
import { getColor, getSize, responsive } from "~/helpers/style";

export const Container = styled.div`
  padding: 24px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  background-color: ${getColor("white")};
  border: solid 1px ${getColor("border")};
  border-radius: ${getSize(0.6)};
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 24px;
  }
`;

export const VideoBox = styled.div`
  flex: 1;
  position: relative;
  background-color: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;

`;

export const VideoPlayer = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 50%;
  padding: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  border: none;
  cursor: pointer;
  z-index: 2;

  svg {
    width: 24px;
    height: 24px;
    fill: #2563eb;
  }
`;

export const TutorialList = styled.div`
  flex: 1;
  margin-top: 24px;

  @media (min-width: 768px) {
    margin-top: 0;
  }
`;

export const TutorialItem = styled.div<{ active?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  color: ${({ active }) => (active ? '#2563eb' : '#111827')};
  font-weight: ${({ active }) => (active ? '600' : '400')};
//   background-color: ${({ active }) => (active ? '#f0f4ff' : 'transparent')};

  &:hover {
    background-color: #f9fafb;
  }
`;

export const TutorialText = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const TutorialDuration = styled.span`
  font-size: 14px;
`;